import type { Command } from '../../types/commands'
import { formatCommandOutput, colorize, formatHighlight, formatURL, formatEmail } from '../colorScheme'
import { dividers, decorations } from '../asciiArt'

export const contactCommand: Command = {
  name: 'contact',
  description: 'Get contact information',
  aliases: ['email', 'reach'],
  category: 'info',
  execute: () => {
    const contactText = `
═══════════════════════════════════════════════════════════
              ${formatHighlight('CONTACT INFORMATION')}
═══════════════════════════════════════════════════════════

┌───────────────────────────────────────────────────────┐
│                                                       │
│  📧  ${formatHighlight('Email')}                                            │
│      ${formatEmail('anderson.reinkordt+can@gmail.com')}                               │
│                                                       │
│  🐙  ${formatHighlight('GitHub')}                                           │
│      ${formatURL('github.com/son1112')}                             │
│                                                       │
│  💼  ${formatHighlight('LinkedIn')}                                         │
│      ${formatURL('linkedin.com/in/anderson-reinkordt')}              │
│                                                       │
└───────────────────────────────────────────────────────┘

${colorize(dividers.double, 'cyan')}

◆━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━◆
  ◈ ${formatHighlight("LET'S CONNECT")}
◆━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━◆

Whether you're interested in:
  ${decorations.starBullet} Practical AI development
  ${decorations.starBullet} Accessible technology collaboration
  ${decorations.starBullet} Open-source tool development
  ${decorations.starBullet} Consulting or contract work
  ${decorations.starBullet} Just want to chat about accessible tech

I'm always open to meaningful conversations about building
technology that truly serves everyone.

╭─ 🔍 WHAT I'M LOOKING FOR ─────────────────────────────────╮
│                                                            │
│  ${decorations.triangleBullet} Technology-focused teams that respect how people      │
│    actually work best                                     │
│  ${decorations.triangleBullet} Complex technical problems requiring deep thinking    │
│    and systematic solutions                               │
│  ${decorations.triangleBullet} Genuine collaboration between engineering & leadership│
│  ${decorations.triangleBullet} Environments where technical judgment is trusted      │
│                                                            │
╰────────────────────────────────────────────────────────────╯

~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~
 💡 Philosophy: ${colorize('"To teach is to learn"', 'brightYellow')}

 I believe in transparent collaboration, sharing both
 ${colorize('successes', 'green')} and failures, and learning in the open.
~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~·~
`

    // Apply automatic formatting for technology names
    const formattedText = formatCommandOutput(contactText, {
      highlightTech: true,
      highlightNumbers: true,
      highlightDates: false,
      highlightPaths: false,
      highlightUrls: true,
    })

    return [
      {
        type: 'info',
        content: (
          <div dangerouslySetInnerHTML={{ __html: formattedText }} />
        ),
      },
    ]
  },
}
